// src/common/PieChartWithCenterText.js
import React, { useEffect, useState } from "react";
import { Chart } from "react-google-charts";

export default function PieChartWithCenterText({
    list, // [{value, label, color}]
    width,
}) {
    const [data, setData] = useState([]);
    const [total, setTotal] = useState(0);
    const [colors, setColors] = useState([]);

    useEffect(() => {
        if(list) {
            const newData = [['Type', 'Count']];
            let newTotal = 0;
            const newColors = [];
            list.forEach((item, index) => {
                newData.push([item.label, item.value]);
                newTotal += item.value;
                newColors.push(item.color);
            });
            setData(newData);
            setTotal(newTotal);
            setColors(newColors);
        }
    }, [list]);

    const options = {
        legend: "none",
        colors: colors,
        pieSliceText: "value",
        pieSliceTextStyle: {
            color: "black", // Makes the text black
            fontSize: 12, // Adjust font size if needed
            //bold: true,
        },
        chartArea: { left: '3%', top: '3%', width: "94%", height: "94%" },
    };

    return (
        <Chart
            chartType="PieChart"
            data={data}
            options={options}
            width={width}
        />
    );
}